
import { Component, Vue, Mixins } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import { getMenuList, deleteMenu, updateMenu } from "@/api/menu";
import { Menu } from "@/types/api/menu";
import print from "@/utils/print";

@Component({ name: 'menu-components-Table' })
export default class Table extends Mixins(Loading, tablePagination) {
  private tableData: Array<Menu> = [];
  private requestSeq: number = 0; // 请求序号，用于丢弃过期响应
  parentId: number = 0;
  parentPage: number = 1; // 进入下级前所在页码

  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(pageNum?: number) {
    const seq = ++this.requestSeq;
    const targetPage = pageNum === undefined ? this.currentPage : pageNum;
    this.showLoading();
    getMenuList({
      pageSize: this.pageSize,
      pageNum: targetPage,
      parentId: this.parentId,
    }).then((res: any) => {
      // 期间已发起更新的请求（切换层级/翻页），丢弃本次过期响应
      if (seq !== this.requestSeq) return;
      const total: number = res.data.total;
      const maxPage: number = Math.max(1, Math.ceil(total / this.pageSize));
      // 目标页已越界（删除末页最后一条、返回上级时父级数据变少），回退到最后一个有效页重查
      if (targetPage > maxPage) {
        this.getData(maxPage);
        return;
      }
      this.tableData = res.data.list;
      this.total = total;
      // 等 total 更新后再同步页码，否则会被分页组件按旧总页数钳制回 1
      this.$nextTick(() => {
        if (seq !== this.requestSeq) return;
        this.currentPage = targetPage;
      });
      this.hideLoading();
    });
  }
  // 查看下级
  viewChildLevel(row: Menu) {
    if (this.parentId == 0) {
      this.parentPage = this.currentPage;
      this.resetCurrent();
      this.parentId = row.id;
      this.$emit("parentId", row.id);
      this.$emit("setChild", true);
      this.getData();
    } else {
      this.backToParent();
    }
  }
  // 返回上级，恢复进入下级前的页码
  backToParent() {
    this.parentId = 0;
    this.$emit("parentId", 0);
    this.$emit("setChild", false);
    this.getData(this.parentPage);
  }
  // 删除
  handleDelete(row: Menu) {
    this.$confirm(`是否要删除菜单编号 ${row.id} ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteMenu({
        id: row.id,
      }).then((res: any) => {
        this.getData();
        this.$message.success("删除成功");
      });
    });
  }
}
